/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type CeproDocsDestroyRequest = {} | null | undefined;
export type CeproDocsDestroyResponse = any;

export type CeproDocsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/cepro_docs/{id}/
 *
 * ```yaml
 * operationId: cepro_docs_destroy
 * tags:
 *   - cepro_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const ceproDocsDestroyOperation = ({ id, ...rest }: CeproDocsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/cepro_docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/cepro_docs/{id}/' };
  };

/**
 * DELETE /dmx-server/cepro_docs/{id}/
 *
 * ```yaml
 * operationId: cepro_docs_destroy
 * tags:
 *   - cepro_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const ceproDocsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CeproDocsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = ceproDocsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
